import { t } from 'i18next';
import { RouteObject } from 'react-router-dom';
import { SetupFunctionClass } from './AttendanceClass/SetupFunctionClass';
import { SubstitutionsSetupPage } from './SubstituionsSetupPage';
import { SubstitutionAppSettingsPage } from './SubstitutionAppSettings/SubstitutionAppSettingsPage';
import { SubstitutionPlanSettingsPage } from './SubstitutionPlanSettings/SubstitutionPlanSettingsPage';
import { SynchronizationPage } from './Synchronization/SynchronizationPage';

export const substitutionSetupRoutes = (baseSlug: string): RouteObject[] => {
  return [
    {
      index: true,
      element: <SubstitutionsSetupPage />,
    },
    {
      path: t('routes.functionClass.slug'),
      element: <SetupFunctionClass />,
      handle: {
        crumb: () => ({
          slug: `${baseSlug}/${t('routes.functionClass.slug')}`,
          title: t('routes.functionClass.title'),
        }),
      },
    },
    {
      path: t('routes.synchronization.slug'),
      element: <SynchronizationPage />,
      handle: {
        crumb: () => ({
          slug: `${baseSlug}/${t('routes.synchronization.slug')}`,
          title: t('synchronizations.synchronization'),
        }),
      },
    },
    {
      path: t('routes.substitutionPlanSettings.slug'),
      element: <SubstitutionPlanSettingsPage />,
      handle: {
        crumb: () => ({
          slug: `${baseSlug}/${t('routes.substitutionPlanSettings.slug')}`,
          title: t('routes.substitutionPlanSettings.title'),
        }),
      },
    },
    {
      path: t('routes.substitutionAppSettings.slug'),
      element: <SubstitutionAppSettingsPage />,
      handle: {
        crumb: () => ({
          slug: `${baseSlug}/${t('routes.substitutionAppSettings.slug')}`,
          title: t('substitutions.app.title'),
        }),
      },
    },
  ];
};
